import { repaint } from '../../js/utils/node';

class Overlay {
  constructor() {
    this.classes = {
      active: 'overlay--active',
    };
    this.isActive = false;

    this.element = document.createElement('div');
    this.element.innerHTML = '&nbsp;';
    this.element.hidden = true;
    this.element.classList.add('overlay');

    document.body.appendChild(this.element);

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  toggle() {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(index = null) {
    this.isActive = true;

    this.element.hidden = false;
    repaint(this.element);
    this.element.style.zIndex = index;
    this.element.classList.add(this.classes.active);
  }

  hide() {
    this.isActive = false;

    this.element.style.zIndex = null;
    this.element.classList.remove(this.classes.active);

    const transitionDuration = parseFloat(getComputedStyle(this.element).getPropertyValue('transition-duration')) || 0;

    if (transitionDuration === 0) {
      this.element.hidden = true;
    } else {
      this.element.addEventListener('transitionend', () => {
        if (this.isActive === false) {
          this.element.hidden = true;
        }
      }, { once: true });
      if (this.isActive === false) {
        this.element.hidden = true;
      }
    }
  }
}

const overlay = new Overlay();

export const { show, hide, toggle } = overlay;
